import React, { Component } from "react"; 
import { Grid, Row, Col } from "@vds/grids"; 
import { connect } from 'react-redux'; 
//import * as XLSX from 'xlsx';
import * as Services from './api';
import * as Utils from './utils';

class AbandonedCart extends Component {
    constructor(props) {
      super(props);
      this.state= {
          apiToken: '',
          targetTestEmail: '',
          endInteraction: false,
      };
  }

    componentDidMount() {
        this.fetchToken();
        this.setState({ endInteraction: true });
    }

    componentDidUpdate = () => {
        if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            this.setState({ endInteraction: false });
        }
    }

  fetchToken = async () => {
      await Services.fetchToken().then(response => {
          this.setState({apiToken: response.data['access_token']})
      });
  }

  postDoLoop = async  (dataRow) => {
      const res = await Services.postDoLoop(this.state.apiToken, dataRow);
              // this.setState({doLoopResponse: response.data});
      await Services.getSelectedBundleInfo(this.state.apiToken, res.data, dataRow) 
      await Services.postCheckAvailability(this.state.apiToken, dataRow);
      return res.data;
  } 

  postUpdateCartInternet= async () => {
      await Services.postUpdateCartInternet(this.state.apiToken)
  }
  postUpdateCartRouter= async () => {
      await Services.postUpdateCartRouter(this.state.apiToken)
  }

    postUpdateCartSABDV= async () => {
        await Services.postUpdateCartSABDV(this.state.apiToken)
    }
    postUpdatePhoneEquipment= async () => {
        await Services.postUpdatePhoneEquipment(this.state.apiToken)
    }
  postSaveCart = async () => {
      await Services.postSaveCart(this.state.apiToken)
      await Services.doSaveCart(this.state.apiToken, this.state.targetTestEmail)
  }
 
  

  getValues = (input) => {
    let { selectedContract } = this.props;
    const selectedContractAgreement = selectedContract === "No annual contract" ? "MonthToMonth" : "TwoYears";

    let prepareObj = {};
    if (input && ((input.BDVInfo) || (input.PhoneInfo))) {
        if (input.BDVInfo?.Plans?.length) {
            prepareObj.businessVoice = input.BDVInfo.Plans.filter(plan => {
                return (plan.Contract === selectedContractAgreement)
            })[0]
        }
        if (input.PhoneInfo?.Plans?.length) {
            prepareObj.standardVoice = input.PhoneInfo.Plans[0];
        }
    } else {
        prepareObj = null;
    }
    return prepareObj;
}

  processData = async  (data) => { 
      // const {headers, content} = Utils.getTableData(data)
        // console.log(data[0]);
        const progress = document.getElementById('progress');
        const step = document.getElementById('step');
        const fios = document.getElementById('totalFios');
        progress.innerHTML = `Process Complete`;
        step.innerHTML = '';
        fios.innerHTML = '';
        let count = 0;
          for(let i=1;i< data?.length;i++){
              const dataRow = Utils.processDataRow(data[i], data[0]); 
              progress.innerHTML  = `Processing ${i} of ${data?.length}....` ;
              step.innerHTML = '...Fetching DoLoop API...';
              const res = await this.postDoLoop(dataRow);
              console.log("=============>", res);
              if(res.DataInfo) {
                  step.innerHTML = '...Adding FIOS product...';
                  await this.postUpdateCartInternet(dataRow);
                  step.innerHTML = '...Adding FIOS Router...';
                  await this.postUpdateCartRouter(dataRow);
                  step.innerHTML = '...Saving Cart...';
                  await this.postSaveCart(dataRow); 
                  count ++;
                  fios.innerHTML = `Fios Processed ${count} of ${i}`;
              } else if(res.PhoneInfo) {
                step.innerHTML = '...Adding Phone product...';
                const customizeProducts = await Services.getCustomizeProducts(this.state.apiToken);
                const valueList = this.getValues(customizeProducts.data);
                console.log(customizeProducts, valueList, res.LQPost)
                if (res?.LQPost?.FiOSDataStatus === 'N' && res?.LQPost?.PhoneStatus === 'Y' && valueList?.standardVoice) {
                    if (res?.LQPost?.HSIStatus === 'Y') {
                        const bundleID = valueList.standardVoice.ProductId;
                        const bRc = valueList.standardVoice.Price;
                        const preferredvoiceFormData = {
                            BID: bundleID,
                            RC: bRc,
                            nlines:1
                        };
                        Services.getPreferredVoiceData(this.state.apiToken ,preferredvoiceFormData);
                        await Services.postUpdatePhoneEquipment(this.state.apiToken, {}); 
                        step.innerHTML = '...Saving Cart...';
                        await this.postSaveCart(dataRow); 
                    } else if (res?.LQPost?.bdvStatus === 'Y' && valueList?.businessVoice) {
                        const bundleID = valueList?.businessVoice?.ProductId;
                        const bRc = valueList?.businessVoice?.Price
                        const SABdvFormData = {
                            bundleID: bundleID,
                            bRc: bRc,
                            Nlines: 1,
                            contract: 'TwoYears'
                        };
                        await Services.postUpdateCartSABDV(this.state.apiToken ,SABdvFormData);
                        const tnData = customizeProducts?.data?.BDVInfo?.TNList?.TNObject[0]?.TN?.replace(/-/g, "");
                        await Services.postUpdatePhoneEquipment(this.state.apiToken, [tnData]); 
                        step.innerHTML = '...Saving Cart...';
                        await this.postSaveCart(dataRow); 
                    }
                } else if (res?.LQPost?.bdvStatus === 'Y' && valueList?.businessVoice) {
                    const bundleID = valueList?.businessVoice?.ProductId;
                    const bRc = valueList?.businessVoice?.Price
                    const SABdvFormData = {
                        bundleID: bundleID,
                        bRc: bRc,
                        Nlines: 1,
                        contract: 'TwoYears'
                    };
                    await Services.postUpdateCartSABDV(this.state.apiToken ,SABdvFormData);
                    const tnData = customizeProducts?.data?.BDVInfo?.TNList?.TNObject[0]?.TN?.replace(/-/g, "");
                    await Services.postUpdatePhoneEquipment(this.state.apiToken, [tnData]); 
                    step.innerHTML = '...Saving Cart...';
                    await this.postSaveCart(dataRow); 
                }
              }
          } 
          progress.innerHTML = `Process Complete`;
          step.innerHTML = '';
  }

  handleUpload = (e) => {
      e.preventDefault();
      var files = e.target.files, f = files[0];
      var reader = new FileReader();
      const self = this;
    //   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(String(email)?.toLowerCase());
      if(!this.state.targetTestEmail) {
        alert("Please provide a valid email to proceed");
        return;
      }
      reader.onload = function (e) {
          const data = e.target.result;
          //let readedData = XLSX.read(data, {type: 'binary'});
         // console.log(readedData.SheetNames)
          //const wsname = readedData.SheetNames[0];
          //const ws = readedData.Sheets[wsname];

          /* Convert array to json*/
          //const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
          //console.log(dataParse);
          //self.processData(dataParse)
      };
      reader.readAsBinaryString(f)
  }

  render() {
      return (
          <>
        <h2>Abandoned Cart Report Generator</h2>
        {/* <button onClick={this.fetchToken}> Fetch API token </button> */}
        <label> Target Test Email  <input   onChange={e=> this.setState({email: e.target.value})} ></input> </label>
        <button onClick={e => {
             const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            //  return re.test(String(email)?.toLowerCase());
        
            if(this.state.email &&  re.test(String(this.state.email)?.toLowerCase())) {
                this.setState({targetTestEmail: this.state.email, email: ''})
            } else {
                alert("Please provide a valid email to proceed");
            }

        }}>Submit</button>
        {/* <button disabled={!this.state.apiToken} onClick={this.postDoLoop}> Call DoLoop API  </button>
        <button disabled={!this.state.apiToken}  onClick={this.postUpdateCartInternet}> Update Cart Internet Plan  </button>
        <button disabled={!this.state.apiToken} onClick={this.postUpdateCartRouter}> Update Cart Router </button>
        <button disabled={!this.state.apiToken} onClick={this.postSaveCart}> Save Cart  </button> */}
        <p>API Token : {this.state.apiToken}</p>
        <p>Test Email : {this.state.targetTestEmail}</p>
        {this.state.targetTestEmail && (<div>
            <hr />
            <label>Upload Excel File</label>
            <input type="file" onChange={this.handleUpload} />
                Processing FIOS enabled zipcodes only 
             <h3 id="progress"> </h3>
             <h5 id="step"> </h5>
            <h5 id="totalFios"> </h5> 
        </div>)}
     
        </>
      )
  }
}
const mapStateToProps = state => {
  const { AddressValidationPage } = state;
    return { 
    }
}
const mapDispatchToProps = (dispatch) => ({ 
});

  AbandonedCart = connect(mapStateToProps, mapDispatchToProps)(AbandonedCart);

export default AbandonedCart;
